import axios from '../../../helpers/custom-axios';
import { confirmation, notify } from '../../../helpers/notifications';

export const fetchUsers = async () => {
  let users = await axios
    .get('/manage/users')
    .then((res) => res)
    .catch((error) => console.error(error));

  let externals = await axios
    .get('/manage/external_users')
    .then((res) => res)
    .catch((error) => console.error(error));

  return { users, externals };
};

export const deleteUser = async (id, callback) => {
  confirmation.destroy(async () => {
    return axios
      .delete(`/manage/users/${id}`)
      .then((res) => {
        notify.alertSuccess('User Deleted');
        callback(res);
      })
      .catch((error) => {
        notify.failure();
        callback(error);
      });
  });
};
